/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  PayLeverageGetAccruedInterestOptions,
  PayLeverageGetAccruedInterestStatus200,
  PayLeverageGetAccruedInterestStatus400,
  PayLeverageGetAccruedInterestStatus401,
  PayLeverageGetAccruedInterestStatus500,
} from '../types/PayLeverageGetAccruedInterest'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { payLeverageGetAccruedInterest } from '../clients/payLeverageGetAccruedInterest'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const payLeverageGetAccruedInterestMutationKey = () =>
  [{ url: '/v1/leverage/accrued_interest/pay' }] as const

export function payLeverageGetAccruedInterestMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = payLeverageGetAccruedInterestMutationKey()
  return mutationOptions<
    PayLeverageGetAccruedInterestStatus200,
    ResponseErrorConfig<
      | PayLeverageGetAccruedInterestStatus400
      | PayLeverageGetAccruedInterestStatus401
      | PayLeverageGetAccruedInterestStatus500
    >,
    PayLeverageGetAccruedInterestOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return payLeverageGetAccruedInterest({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Pay current accrued leverage interest for a specific user
 * {@link /v1/leverage/accrued_interest/pay}
 */
export function usePayLeverageGetAccruedInterest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PayLeverageGetAccruedInterestStatus200,
      ResponseErrorConfig<
        | PayLeverageGetAccruedInterestStatus400
        | PayLeverageGetAccruedInterestStatus401
        | PayLeverageGetAccruedInterestStatus500
      >,
      PayLeverageGetAccruedInterestOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? payLeverageGetAccruedInterestMutationKey()

  const baseOptions = payLeverageGetAccruedInterestMutationOptions(config) as UseMutationOptions<
    PayLeverageGetAccruedInterestStatus200,
    ResponseErrorConfig<
      | PayLeverageGetAccruedInterestStatus400
      | PayLeverageGetAccruedInterestStatus401
      | PayLeverageGetAccruedInterestStatus500
    >,
    PayLeverageGetAccruedInterestOptions,
    TContext
  >

  return useMutation<
    PayLeverageGetAccruedInterestStatus200,
    ResponseErrorConfig<
      | PayLeverageGetAccruedInterestStatus400
      | PayLeverageGetAccruedInterestStatus401
      | PayLeverageGetAccruedInterestStatus500
    >,
    PayLeverageGetAccruedInterestOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PayLeverageGetAccruedInterestStatus200,
    ResponseErrorConfig<
      | PayLeverageGetAccruedInterestStatus400
      | PayLeverageGetAccruedInterestStatus401
      | PayLeverageGetAccruedInterestStatus500
    >,
    PayLeverageGetAccruedInterestOptions,
    TContext
  >
}
